// apps/office/src/lib/emailService.js
import pb from './pocketbaseClient';

/**
 * Sends a quotation/invoice email.
 * 1) Tries backend route /api/send-document-email (PocketBase custom route).
 * 2) Falls back to mailto: link if backend is not configured yet.
 */
export async function sendDocumentEmail({
  to, cc, subject, message,
  documentType, documentNumber,
  clientName, pdfBlob,
}) {
  if (!to) throw new Error('Recipient email is required');

  const form = new FormData();
  form.append('to', to);
  if (cc) form.append('cc', cc);
  form.append('subject', subject || '');
  form.append('message', message || '');
  form.append('documentType', documentType || 'document');
  form.append('documentNumber', documentNumber || '');
  form.append('clientName', clientName || '');

  if (pdfBlob) {
    form.append(
      'pdf',
      pdfBlob,
      `${documentType || 'document'}_${documentNumber || Date.now()}.pdf`
    );
  }

  try {
    const token = pb.authStore.token;
    const baseUrl = pb.baseUrl || pb.baseURL || '';
    const res = await fetch(`${baseUrl}/api/send-document-email`, {
      method: 'POST',
      headers: { Authorization: token },
      body: form,
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(txt || `HTTP ${res.status}`);
    }
    return { success: true, method: 'server' };
  } catch (err) {
    // Fallback: open default email client
    console.warn('[emailService] backend failed, using mailto fallback:', err.message);

    const body = `${message || ''}\n\n� ${documentType} ${documentNumber}`;
    const mailto = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(
      subject || ''
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailto;
    return { success: true, method: 'mailto', warning: err.message };
  }
}